import { OrdersService } from './../../services/order/orders.service';
import { Subscription } from 'rxjs';
import { trigger, transition, style, query, group, animate } from '@angular/animations';
import { Component, ElementRef, ViewChild, PLATFORM_ID, Inject } from '@angular/core';
import { PdvService } from '@app/services/pdv/pdv.service';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
    moduleId: module.id,
    selector: 'contact',
    templateUrl: 'contact.component.html',
    styleUrls: ['contact.component.scss'],
    animations: [
        trigger('fade', [
            transition('* <=> *', [
                group([
                    query('#main-contact-form', [
                        style({ opacity: 0, transform: 'translate(-50%,0)' }),
                        animate('200ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                    ], { optional: true }),
                    query('.contact-info', [
                        style({ opacity: 0, transform: 'translate(50%,0)' }),
                        animate('200ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                    ], { optional: true })
                ])
            ])
        ])
    ]
})
export class ContactComponent {
    pdv: any = {};
    subscriptions: Subscription[] = [];
    email = "";
    contact = {
        name: "",
        email: "",
        subject: "",
        message: "",
        pdv: ""
    }
    contactErreur = {
        name: false,
        email: false,
        subject: false,
        message: false
    }
    loader = false;
    send = false;
    ourApp = false;
    @ViewChild('maplink') maplink: ElementRef
    constructor(
        private pdvService: PdvService,
        private webs: WebSiteUsersService,
        @Inject(PLATFORM_ID) private platformId: Object,
        private orderService : OrdersService
    ) {
        let subs2 = this.pdvService.pdv.subscribe(
            pdv => {
                this.pdv = pdv;
            }
        );
        this.contact.pdv = pdvService.idPdv;
        this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
        this.subscriptions.push(subs2);
    }
    ngOnInit() {
        setTimeout(
            () => {
                var coords = this.pdv.address;
                coords = coords.replace(/\ /g, "+");
                this.maplink.nativeElement.setAttribute("href", this.GetMapUrl(coords));
            }, 200
        )
    }

    GetMapUrl(q) {
        if (isPlatformBrowser(this.platformId)) {
            var ua = navigator.userAgent.toLowerCase();
            var windows8 = ua.indexOf("windows nt 6.2") > -1
            var mobile = ua.indexOf("mobile") > -1 || ua.indexOf("wp7") > -1;
            var iPhone = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
            var android = ua.indexOf("android") > -1;
            var msie = ua.indexOf("msie") > -1;
            if (mobile && iPhone) return ("http://maps.google.com/maps?q=" + q);
            else if (mobile && android) return ("geo:0,0?q=" + q);
            else if (mobile && msie) return ("maps:" + q);
            else if (windows8) return ("bingmaps:?q=" + q); else
                return ("http://maps.google.com/maps?q=" + q);
        }
    }
    contactUs() {
        this.contactErreur = {
            name: false,
            email: false,
            subject: false,
            message: false
        }
        let error = 0;
        if (this.contact.name.trim() == "") {
            error++;
            this.contactErreur.name = true;
        }
        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.contact.email))) {
            error++;
            this.contactErreur.email = true;
        }
        if (this.contact.subject.trim() == "") {
            error++;
            this.contactErreur.subject = true;
        }
        if (this.contact.message.trim() == "") {
            error++;
            this.contactErreur.message = true;
        }
        if (error == 0) {
            this.loader = true;
            this.webs.contactUs(this.contact).subscribe(
                () => {
                    this.loader = false;
                    this.send = true;
                }
            )
        }
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnDestroy() {
        this.unsubscribe();
    }
}
